import assets from '../../../assets/**/*.svg';

export default () => {
  return (
    <div className="loaders">
      <img src={assets.icons.spinner} height={0} />
    </div>
  );
};
